module.exports = __webpack_public_path__ + "static/media/eleconomista.2aeb985c.jpg";